"use client";

import React from "react";

import Base from "@/templates/Base";

import styles from "./gran-plus.module.scss";

export default function PageClient() {
  const handleTrackedClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const target = event.currentTarget;
    const dataTrack = target.getAttribute("data-track");
    const ctaText = target.getAttribute("cta-text");
    const ctaLocationClass = target.getAttribute("data-cta-location-class");

    typeof window !== "undefined" &&
      typeof window.gtag === "function" &&
      window.gtag("event", "click_cta_lp", {
        cta_text: ctaText,
        cta_location_class: ctaLocationClass,
        data_track: dataTrack
      });

    document.cookie = `lastSelectPromotionName=${dataTrack};path=/;domain=.${location.hostname.replace(/^www\./i, "")}`;
  };
  return (
    <Base>
      <main className={styles.main}>
        <section className={`${styles.banner} ${styles.dobra1_banner}`}>
          <a
            href="https://www.cobasi.com.br/pesquisa?hotsite=1432"
            target="_blank"
            cta-text="Banner Principal"
            data-cta-location-class="dobra1_banner"
            data-track="lp-gran-plus_Banner"
            onClick={handleTrackedClick}
          >
            <img
              className={styles["img-desk"]}
              src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-banner-principal-new.gif"
              alt="Texto inspire"
            />
            <img
              className={styles["img-mob"]}
              src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-banner-principal-mobile-new.gif"
              alt="Texto inspire"
            />
          </a>

          <div className={styles.container}>
            <h1 className="heading-sm">
              GranPlus tem uma{" "}
              <strong>
                linha completa com variedade de sabores para todos os portes e
                fases da vida
              </strong>{" "}
              do seu pet. Da refeição diária aos petiscos, cada receita{" "}
              <strong>combina sabor e equilíbrio,</strong> assim garante
              nutrição de qualidade com ingredientes selecionados.
            </h1>
          </div>
        </section>

        <section className={styles.especial}>
          <div className={styles.container}>
            <div className={styles.content}>
              <h2 className="heading-lg">O que a GranPlus tem de especial?</h2>
              <h3 className="heading-sm">
                Tudo o que seu pet precisa para uma alimentação equilibrada e
                saborosa, todos os dias!
              </h3>
              <div className={styles["photo-mob"]}>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-banner-especial-mobile.png"
                  alt="Imagem especial"
                />
              </div>
              <div className={styles.photo}>
                <div className={styles.column}>
                  <div className={styles.items}>
                    <h4>Ingredientes nobres</h4>
                    <p className="heading-xs">
                      Salmão, Peru e Ovelha como fontes de proteína de alta
                      qualidade.
                    </p>
                  </div>
                  <div className={`${styles.items} ${styles.item2}`}>
                    <h4>Sem corantes e aromas artificiais</h4>
                    <p className="heading-xs">
                      Mais saúde e bem-estar para cães e gatos.
                    </p>
                  </div>
                </div>

                <div className={`${styles.column} ${styles.column2}`}>
                  <div className={styles.items}>
                    <h4>Linha Completa</h4>
                    <p className="heading-xs">
                      Rações secas, úmidas (patês e sachês) e snacks para uma
                      rotina nutritiva.
                    </p>
                  </div>
                  <div className={`${styles.items} ${styles.item4}`}>
                    <h4>Benefícios comprovados</h4>
                    <p className="heading-xs">
                      Auxilia na saúde intestinal, mantém a pelagem brilhante e
                      fortalece o coração.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className={`${styles.gourmet} ${styles.dobra3_gourmet}`}>
          <div className={styles.title}>
            <h3 className="heading-lg">Conheça as linhas GranPlus</h3>
          </div>
          <div className={styles.container}>
            <div className={styles.subtitle}>
              <h3 className="heading-xl">Gourmet:</h3>
              <h4>Sabor e nutrição premium</h4>
              <p>
                Proporciona uma experiência irresistível para{" "}
                <strong>cães e gatos!</strong>
              </p>
            </div>

            <div className={styles.content}>
              <div>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-racao.png"
                  alt="Imagem de ração"
                />
              </div>
              <div className={styles.box}>
                <div className={styles.text}>
                  <h4 className="heading-md">
                    Com ingredientes nobres,
                    <br /> essa linha é repleta de benefícios:
                  </h4>
                  <div className={styles.wrapper}>
                    <p className="heading-xs">Antioxidantes naturais</p>
                    <p className={`heading-xs ${styles.item2}`}>
                      Probióticos MOS para o equilíbrio intestinal
                    </p>
                    <p className={`heading-xs ${styles.item3}`}>
                      Taurina para a saúde do coração felino
                    </p>
                    <p className={`heading-xs ${styles.item4}`}>
                      Nutrientes essenciais para pele, pelo e ossos fortes
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.refeicao}>
              <h4>
                Oferece uma refeição suculenta ao seu pet com os patês e sachês
                que são completos e mais!
              </h4>
              <div className={styles["photo-mob"]}>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-saches-ref-mobile.png"
                  alt="Imagem de ração"
                />
              </div>
              <div className={styles.photo}>
                <p className="heading-xs">São fonte de hidratação</p>
                <p className={`heading-xs ${styles.item2}`}>
                  Possuem minerais orgânicos de alta absorção para melhor
                  aproveitamento.
                </p>
              </div>
              <a
                className="btn btn-orange"
                href="https://www.cobasi.com.br/pesquisa?hotsite=936"
                target="_blank"
                data-track="lp-gran-plus_Gourmet"
                cta-text="Linha Gourmet"
                data-cta-location-class="dobra3_gourmet"
                onClick={handleTrackedClick}
              >
                Confira a linha Gourmet completa
              </a>
            </div>
            <div className={styles.frame}>
              <img
                src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-frame-flor.png"
                alt="Imagem de folha"
              />
            </div>
          </div>
        </section>

        <section className={`${styles.menu} ${styles.dobra4_menu}`}>
          <div className={styles.container}>
            <div className={styles.title}>
              <h3 className="heading-xl">Menu:</h3>
              <h4>Nutrição funcional para cada necessidade</h4>
              <p>
                Oferece uma <strong>alimentação completa e funcional,</strong>{" "}
                feita para atender necessidades específicas e garantir o
                bem-estar diário do seu pet.
              </p>
            </div>

            <div className={styles.content}>
              <div>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-racao-menu.png"
                  alt="Imagem de ração"
                />
              </div>
              <div className={styles.box}>
                <div className={styles.text}>
                  <p className="heading-xs">Saúde dental</p>
                  <p className={`heading-xs ${styles.item2}`}>
                    Suporte articular
                  </p>
                  <p className={`heading-xs ${styles.item3}`}>
                    Versão light para controle de peso
                  </p>
                </div>
              </div>
            </div>
            <a
              className="btn btn-orange"
              href="https://www.cobasi.com.br/pesquisa?hotsite=1519"
              target="_blank"
              data-track="lp-gran-plus_Menu"
              cta-text="Linha Menu"
              data-cta-location-class="dobra4_menu"
              onClick={handleTrackedClick}
            >
              Confira a linha Menu completa
            </a>
            <div className={styles.frame}>
              <img
                src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-frame-flor-orange.png"
                alt="Imagem de folha"
              />
            </div>
          </div>
        </section>

        <section
          className={`${styles.menu} ${styles.choice} ${styles.dobra5_choice}`}
        >
          <div className={styles.container}>
            <div className={styles.title}>
              <h3 className="heading-xl">Choice:</h3>
              <h4>Nutrição essencial para o dia a dia</h4>
              <p>
                Uma <strong>linha equilibrada e nutritiva,</strong> feita para o
                bem-estar diário de cães e gatos em todas as fases da vida.
              </p>
            </div>

            <div className={styles.content}>
              <div>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-racao-choice.png"
                  alt="Imagem de ração"
                />
              </div>
              <div className={styles.box}>
                <div className={styles.text}>
                  <p className="heading-xs">Saúde intestinal</p>
                  <p className={`heading-xs ${styles.item2}`}>
                    Palatabilidade elevada
                  </p>
                  <p className={`heading-xs ${styles.item3}`}>
                    Nutrientes essenciais para uma vida saudável
                  </p>
                </div>
              </div>
            </div>
            <a
              className="btn btn-orange"
              href="https://www.cobasi.com.br/pesquisa?hotsite=937"
              target="_blank"
              data-track="lp-gran-plus_Choice"
              cta-text="Linha Choice"
              data-cta-location-class="dobra5_choice"
              onClick={handleTrackedClick}
            >
              Confira a linha Choice completa
            </a>
            <div className={styles.frame}>
              <div>
                <img
                  className={styles.first}
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-frame-flores.png"
                  alt="Imagem de folha"
                />
              </div>
              <div>
                <img
                  className={styles.second}
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-frame-flores-big.png"
                  alt="Imagem de folha"
                />
              </div>
            </div>
          </div>
        </section>

        <section className={styles.biscoitos}>
          <div className={styles["banner-biscoito"]}>
            <img
              src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-photo-biscoitos.png"
              alt=""
            />
          </div>
          <div className={styles["banner-biscoito-mob"]}>
            <img
              src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-biscoitos-mobile.png"
              alt=""
            />
          </div>
          <div className={styles.container}>
            <div className={styles.title}>
              <h3 className="heading-xl">Biscoitos GranPlus</h3>
              <h4>
                Assados, crocantes e nutritivos!{" "}
                <strong>
                  Feitos com ingredientes integrais e enriquecidos com 13
                  vitaminas
                </strong>
                , são a escolha perfeita para um pet feliz e cheio de energia.
              </h4>
              <div className={styles.info}>
                <p className="heading-xs">
                  Fonte de fibras para a saúde digestiva
                </p>
                <p className={`heading-xs ${styles.item2}`}>
                  Auxilia na saúde dental
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className={`${styles.sabores} ${styles.dobra6_biscoitos}`}>
          <div className={styles.content}>
            <h5 className="heading-md">Disponível nos sabores:</h5>
            <div className={styles.container}>
              <div className={styles.wrapper}>
                <div className={styles.group}>
                  <p className="heading-sm">
                    Sabor leite
                    <br /> para os filhotes
                  </p>
                  <p className={`heading-sm ${styles.item2}`}>
                    Sabor carne
                    <br /> para cães adultos
                  </p>
                </div>
                <p className={`heading-sm ${styles.item3}`}>
                  Sabor frango
                  <br /> para cães adultos
                </p>
              </div>
              <div>
                <a
                  className="btn btn-orange"
                  href="https://www.cobasi.com.br/pesquisa?hotsite=938"
                  target="_blank"
                  data-track="lp-gran-plus_Biscoitos"
                  cta-text="Biscoitos"
                  data-cta-location-class="dobra6_biscoitos"
                  onClick={handleTrackedClick}
                >
                  Confira os produtos
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className={`${styles.calculadora} ${styles.dobra7_calcule}`}>
          <div className={styles.container}>
            <div className={styles.content}>
              <div className={styles.wrapper}>
                <h3>A quantidade certa para o seu pet!</h3>
                <h4 className="heading-md">
                  Na dúvida sobre a quantidade ideal de ração para o seu pet?
                </h4>
                <div className={styles["photo-mob"]}>
                  <img
                    src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-photo-racao-quantidade.png"
                    alt="Imagem de ração"
                  />
                </div>
                <p className="heading-xs">
                  Com a <strong>Calculadora GranPlus</strong>, você descobre a
                  porção ideal de acordo com peso, idade e nível de atividade.
                </p>
                <div className={styles.items}>
                  <p>Alimentação equilibrada e sem desperdícios</p>
                  <p>Recomendações personalizadas para cães e gatos</p>
                  <p className={styles.item3}>Fácil e rápido de usar!</p>
                </div>
              </div>
              <div>
                <img
                  className={styles.racao}
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-gran-plus-2025-photo-racao-quantidade.png"
                  alt="Imagem de ração"
                />
              </div>
            </div>
            <div>
              <a
                className="btn btn-orange"
                href="https://granplus.com.br/quantidade-diaria/"
                target="_blank"
                data-track="lp-gran-plus_Calcule"
                cta-text="Calcule quantidade"
                data-cta-location-class="dobra7_calcule"
                onClick={handleTrackedClick}
              >
                Descubra a porção ideal para seu pet
              </a>
            </div>
          </div>
        </section>
      </main>
    </Base>
  );
}
